// extracted by mini-css-extract-plugin
export var cancelButton = "_pe-5";
export var content = "_pe-3";
export var createButton = "_pe-6";
export var drawerContainer = "_pe-0";
export var footer = "_pe-2";
export var header = "_pe-1";
export var orderFormColumn = "_pe-4";